import { useTranslation } from 'react-i18next';

import { useState } from 'react';

import { IconButton } from '@sdb/planning-ui';

import { ListSubheader, Switch, Tooltip } from '@mui/material';

import { Dialog } from 'components/shared';

import { PickerRow, PickerRows } from '../../EmploymentHours.styles';

import type { DetailTablePickerProps } from './HoursRowDetailPanel.types';

/**
 * Which detail tables are shown, mirroring the home page's "add widget" dialog
 * (`roster-portal/home/quality-monitor/AddWidgetTile.tsx`): one switch per table, grouped by section.
 */
const DetailTablePicker = ({
  sections,
  isRemoved,
  onToggle
}: DetailTablePickerProps) => {
  'use memo';

  const { t } = useTranslation('common', {
    keyPrefix: 'employmentHours.detail'
  });
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip title={t('pickTables')}>
        <IconButton
          type="plus"
          color="secondary"
          size="small"
          aria-label={t('pickTables')}
          onClick={() => setIsOpen(true)}
        />
      </Tooltip>

      <Dialog
        open={isOpen}
        handleClose={() => setIsOpen(false)}
        title={t('availableTables')}
      >
        <PickerRows>
          {sections.map((section) => (
            <li key={section.id}>
              <ListSubheader disableGutters>{section.title}</ListSubheader>
              <PickerRows>
                {section.tables.map((table) => (
                  <PickerRow key={table.group}>
                    {table.title}
                    <Switch
                      checked={!isRemoved(table.group)}
                      onChange={() => onToggle(table.group)}
                      slotProps={{ input: { 'aria-label': table.title } }}
                    />
                  </PickerRow>
                ))}
              </PickerRows>
            </li>
          ))}
        </PickerRows>
      </Dialog>
    </>
  );
};

export default DetailTablePicker;
